import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MigrationAccountingFolderJournalUpdateRequest } from '../entities/journal/migration-accounting-folder-journal-update-request.entity';
import { environment } from 'src/environments/environment';

@Injectable()
export class MigrationJournalService {

  constructor(
      private http: HttpClient,
  ) { }

  downloadFile$(folderId: number, journalId: number): Observable<Blob> {
    const url = `${environment.apiURL}/migration/folder/${folderId}/journals/${journalId}`;

    return this.http.get(url, {responseType: 'blob'});
  }

  updateManyTypeAndState$(folderId: number, request: MigrationAccountingFolderJournalUpdateRequest): Observable<void> {
    const url = `${environment.apiURL}/migration/folder/${folderId}/journals/update-many-type-and-state`;

    return this.http.post<void>(url, request);
  }
}
